import {objectType, propertyInitStatus} from "_src/constants";
import {syncProjectContent} from "_src/client/project_content";
import reformer from "_src/reformer/reformer";

const _properties = new Map();
const _ordering = [];
let _updated = false;
export default {
  version: "",

  addProperty(property) {
    _properties.set(property.getValue("id"), property);
    _updated = true;
  },

  //designed to be used in friend classes: reformer, wrapper
  _getProperty(id) {
    return _properties.get(id);
  },

  removeObject(objectID) {
    _properties.delete(objectID);
    _ordering.splice(0, _ordering.length,..._ordering.filter(item => item["id"] !== objectID));
    _updated = true;
  },

  setPropertyValue(id, propertyName, value) {
    _properties.get(id).insertValue(propertyName, value);
    _updated = true;
  },

  syncPrimitivesCount(object) {
    const property = _properties.get(object.getID());
    if (property.getValue("initStatus") !== propertyInitStatus.COMPLETE) return;

    let numPolygons = 0;
    let numVertices = 0;
    for (const frameProperty of property.getValue("frames")) {
      const frame = object.frames.find(frame => frame.getID() === frameProperty.getValue("id"));
      if (!frame) {
        continue;
      }

      frameProperty.insertValue("numPolygons", frame.numPolygons);
      frameProperty.insertValue("numVertices", frame.numVertices);

      numPolygons += frame.numPolygons;
      numVertices += frame.numVertices;
    }

    if (object.type === objectType.SURFELS) {
      property.insertValue("numSurfels", numVertices);
    } else {
      property.insertValue("numPolygons", numPolygons);
      property.insertValue("numVertices", numVertices);
    }

    _updated = true;
  },

  async combineObjectStructure(objectID) {
    const objectProperty = _properties.get(objectID);
    if (objectProperty.getValue("initStatus") !== propertyInitStatus.INCOMPLETE) return;

    objectProperty.setValue("initStatus", propertyInitStatus.INITIALIZING);
    if (this.version >= 6) await reformer.combineObjectStructure(objectProperty);
    objectProperty.setValue("initStatus", propertyInitStatus.COMPLETE);
    _updated = true;
  },

  setPhotoState(photoGroupID, photoID, state) {
    const photoGroupProperty = _properties.get(photoGroupID);
    if (!photoGroupProperty) return;
    const photo = photoGroupProperty.getValue("photos").find(prop => prop["id"] === photoID);
    if (!photo) return;
    photo["state"] = state;

    _updated = true;
  },

  setSubSectionProperty(measureID, sectionIDx, contourIDx, propName, value) {
    const sectionGroupProperty = _properties.get(measureID);
    const sectionProperty = sectionGroupProperty.getValue("geometries")[sectionIDx];
    const targetProperty = contourIDx !== undefined ? sectionProperty["contours"][contourIDx] : sectionProperty;
    targetProperty[propName] = value;

    _updated = true;
  },

  getPropertiesByType(type) {
    return Array.from(_properties.values()).filter(data => data.getValue("type") === type);
  },

  setOrdering(ordering) {
    _ordering.length = 0;
    _ordering.push(...ordering);

    _updated = true;
  },

  getOrdering() {
    return _ordering.slice();
  },

  checkForUpdates() {
    if (!_updated) return;
    syncProjectContent(this);
    _updated = false;
  },

  _cleanup() {
    _properties.clear();
    _ordering.length = 0;
    _updated = false;
  },
}
